import { thumbHashToDataURL } from 'thumbhash';

export function thumbHashToImageUrl(base64url: string): string {
  const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return thumbHashToDataURL(bytes);
}
